var map = {
	"./animation.js": 67534,
	"./auth.js": 20861,
	"./certificate.js": 27155,
	"./chat.js": 41993,
	"./cirt.js": 11991,
	"./clickable map.js": 34688,
	"./collaborative editor.js": 20150,
	"./cus.js": 19967,
	"./dashboard.js": 55045,
	"./documentation.js": 54403,
	"./email.js": 2944,
	"./events.js": 79348,
	"./feed.js": 95080,
	"./gameboard.js": 87541,
	"./group.js": 82718,
	"./individual editor.js": 71207,
	"./lang.js": 30221,
	"./maps.js": 7688,
	"./navbar.js": 54089,
	"./notes.js": 487,
	"./research consent.js": 9757,
	"./risk assessment.js": 16948,
	"./roles.js": 8970,
	"./survey.js": 6748,
	"./tableview.js": 15226,
	"./teacherClass.js": 75578,
	"./team profile.js": 81214,
	"./terminal.js": 81019,
	"./tour.js": 87155,
	"./video call.js": 74770,
	"./video recorder.js": 96154,
	"./video.js": 85455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46408;